module.exports = __webpack_public_path__ + "img/3dForm6.1bdd3a67.svg";